<app-efa-sub-list>
  <a actions class="link" routerLink="assign">
    <!-- {{ 'organization.assign' | cxTranslate }} -->
    <cx-icon
    class="u-pointer"
    [type]="iconTypes.PENCIL">
    </cx-icon>
  </a>
</app-efa-sub-list>
